import Footer from '../../components/Footer'
import Header from '../../components/Header'
import DashboardPanel from './DashboardPanel'

function Dashboard() {
  return (
    <div className='dashboard'>
      <Header/>
      <DashboardPanel/>
      <Footer/>
    </div>
  )
}

export default Dashboard